import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import nbrApi from '../../../services/nbrApi'
import Swal from 'sweetalert2'
import RoomItemForm from '../../components/MangeHKT/RoomITemMappingForm'

function EditRoomItemMapper() {
    const navigate = useNavigate()
    const { id } = useParams()
    const [data, setData] = useState([])
    let editManageHktData = JSON.parse(localStorage?.getItem('edit-manage-hkt')) || {}
    let editMappingDefault = JSON.parse(localStorage.getItem('edit-mapping-default')) || {}
    let { mhkt_id } = editManageHktData
    let { mririt_id, property } = editMappingDefault
    let selectedProperty = JSON.parse(localStorage.getItem('selectedProperty')) || {}

    // handleGoBack
    const handleGoBack = () => {
        navigate(mhkt_id ? '/mapping-edit/'+ mhkt_id : 'manage-requests')
    }


    // create action
    const handleForm = async (propsData) => {
        const { property, roomItem, task } = propsData
        const data = {
            mhkt_id: Number(mhkt_id),
            properties_id: Number(property ? property : selectedProperty?.value),
            mririt_id: mririt_id,
            rit_id: Number(task),
            ri_id: Number(roomItem),
            status: 'active'
        };

        if (data) {
            try {
                const response = await nbrApi.post('/updatemririt', data, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (response.status === 200) {
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Mapping updated successful',
                        showConfirmButton: false,
                        timer: 2000,
                    }).then(() => {
                        handleGoBack('/manage-requests');
                    });
                }
            } catch (error) {
                console.error('Error fetching data:', error.message)
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Mapping Create failed',
                    showConfirmButton: false,
                    timer: 2000,
                })
            }
        } else {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Mapping Create failed',
                showConfirmButton: false,
                timer: 2000,
            })
        }

    }

    useEffect(() => {
        if (id) {
            const getData = async () => {
                const responsex = await nbrApi.get(`/getmriritcombo?properties_id=${property}&mririt_id=${id}`);
                const responseDatax = responsex.data;
                if (responseDatax) {
                    let task_list = responseDatax?.[2] || []
                    let task_type_list = responseDatax?.[3] || []
                    let room_item_list = responseDatax?.[4] || []
                    let room_item_type_list = responseDatax?.[5] || []

                    let selectedOptionItemTasks = responseDatax?.[1]?.[0]?.rit_id || ''
                    let selectedOptionRoomItems = responseDatax?.[1]?.[0]?.ri_id || ''
                    let selectedOptionRoomItemTypes = responseDatax?.[1]?.[0]?.roomitemtypes_id
                    let selectedOptionTaskTypes = responseDatax?.[1]?.[0]?.tasktypes_id
                    let selectedTaskType = responseDatax?.[1]?.[0]?.tasktypes_id

                    let data = {
                        selectedData: {
                            property,
                            selectedOptionItemTasks,
                            selectedOptionRoomItems,
                            selectedOptionRoomItemTypes,
                            selectedOptionTaskTypes,
                            selectedTaskType
                        },
                        task_list,
                        task_type_list,
                        room_item_list,
                        room_item_type_list
                    }
                    setData(data)
                }
            }
            getData()

        }
    }, [id])

    // render
    return (
        <div className="row">
            <div className="col-xxl-12">
                <div className="card">
                    <div className="card-header">
                        <h4 className="heading me-2">Edit Room Mapping</h4>
                        <button type='button' onClick={handleGoBack} className='btn btn-primary btn-sm'><i className='fa fa-undo' /> Go Back</button>
                    </div>

                    <div className="card-body col-lg-5">
                        <RoomItemForm handleAction={handleForm} data={data} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditRoomItemMapper